export default __webpack_public_path__ + "static/media/arrow-primary-right.10955c7a.svg";